import React, { useState } from 'react';

import { Eye, EyeOff } from 'lucide-react';

interface PasswordFieldProps {
  id: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  placeholder?: string;
  disabled?: boolean;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  id,
  value,
  onChange,
  placeholder,
  disabled,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = (): void => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="relative mt-1">
      <input
        type={showPassword ? 'text' : 'password'}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="cg-input"
        disabled={disabled}
      />
      <div
        className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
        onClick={togglePasswordVisibility}
      >
        {showPassword ? (
          <EyeOff className="h-5 w-5 text-muted" />
        ) : (
          <Eye className="h-5 w-5 text-muted" />
        )}
      </div>
    </div>
  );
};

export default PasswordField;
